import * as React from "react";
import { Pressable, ScrollView, StyleSheet, View } from "react-native";
import { Text, useTheme } from "react-native-paper";
import HeaderNav from "app/shared/components/header-nav/header-nav";
import { Block } from "@block";
import { StackActions, useNavigation } from "@react-navigation/native";
import { useTranslation } from "react-i18next";
import { NavTitleBar, SubtitleNavTitleBar } from "app/shared/components/nav-title-bar/nav-title-bar";
import { spacing } from "@styles/spacing";
import { useDesktopMediaQuery } from "@media-query";
import IconsYellowBanking from "app/shared/components/icons/icon-yellow-banking/IconsYellowBanking";
import ScreenNameType from "@navigation/nav-screens";
import { StackSpacing } from "@components/spacing";
import { globalShowDialog, globalShowFuture } from "app/shared/util/future";
import Animated, { useAnimatedStyle, withSpring } from "react-native-reanimated";
import { pushAppFlyer } from "app/shared/util/app-flyer";
import ChangePassword, { createGlobalModalChangePassword, globalModalChangePassword } from "./change-password/change-password";
// import appConfig from "app/config/app-config";

type PressAbleState = Readonly<{
  pressed: boolean;
  hovered?: boolean;
  focused?: boolean;
}>;

interface Item {
  code: number;
  icon: string;
  name: string;
  screen: string;
  action: string;
}

const Settings = () => {
  const { t } = useTranslation();
  const isDesktop = useDesktopMediaQuery();
  const { dispatch } = useNavigation();
  const { colors, fonts } = useTheme();

  const [globalModalChangePasswordRef] = React.useState<React.RefObject<any>>(createGlobalModalChangePassword());


  const subtitlesArrays: Array<SubtitleNavTitleBar> = [
    {
      name: t("FUNC_TRANG_CHU"),
      onPressSubtitle: () => {
        dispatch(StackActions.replace(ScreenNameType.HOME));
      },
    },
    {
      name: t("SETTING_CAI_DAT"),
      onPressSubtitle: () => {},
    },
  ];

  const styles = React.useMemo(
    () =>
      StyleSheet.create({
        textName: { ...fonts.medium, color: colors.text, textAlign: "center", maxWidth: 164, alignSelf: "center" },
      }),
    [colors.text, fonts.medium],
  );

  const data: Item[] = [
    { code: 0, icon: "Quanlydanhsachthuhuong", name: t("SETTING_QL_DS_THU_HUONG"), screen: "", action: "beneficiary_manage" },
    { code: 1, icon: "Doimatkhaudangnhap", name: t("SETTING_DOI_MAT_KHAU_DANG_NHAP"), screen: ScreenNameType.ChangePassword, action: "change_pass" },
    { code: 2, icon: "Caidatphuongthucxacthuc", name: t("SETTING_PHUONG_THUC_XAC_THUC"), screen: "", action: "authentication_method" },
    { code: 3, icon: "Caidattinhnangyeuthich", name: t("SETTING_TINH_NANG_YEU_THICH"), screen: "", action: "favourite_function" },
    { code: 4, icon: "Caidattaikhoanmacdinh", name: t("SETTING_TK_MAC_DINH"), screen: "", action: "default_account" },
    { code: 5, icon: "CaidatthaydoigoihanmucGD", name: t("SETTING_GOI_HAN_MUC"), screen: "", action: "change_transaction_limit" },
    { code: 6, icon: "Caidatthongbao", name: t("SETTING_THONG_BAO"), screen: "", action: "notification_setup" },
    { code: 7, icon: "Caidatchude", name: t("SETTING_CAI_DAT_CHU_DE"), screen: "", action: "theme_setup" },
  ];

  const handlerParamsAppFlyer = (action: string) => {
    console.log("handlerParamsAppFlyer");
    //beneficiary_manage, change_pass, authentication_method, favourite_function, default_account, change_transaction_limit, notification_setup, theme_setup
    return {
      eventName: "af_setup",
      params: {
        af_channel: "ib_rb",
        af_setup_action: action,
      },
    };
  };

  const onPressItem = (item: Item, index: number | string) => {
    const { eventName, params } = handlerParamsAppFlyer(item.action);
    pushAppFlyer(eventName, params);
    switch (index) {
      case 1:
        showModal();
        break;
      default:
        globalShowFuture();
        break;
    }
  };

  const showModal = () => {
    globalModalChangePassword.show(globalModalChangePasswordRef);
  };

  return (
    <Block flex={1}>
      <ScrollView>
        <HeaderNav />
        <NavTitleBar title={t("SETTING_CAI_DAT")} subtitles={subtitlesArrays} />
        <Block pv={spacing.medium} ph={isDesktop ? "5%" : 0}>
          <View style={{ flexDirection: "row", flexWrap: "wrap" }}>
            {data.map((_item, _index) => (
              <View key={_index} style={[{ maxWidth: isDesktop ? "25%" : "50%", minWidth: isDesktop ? "25%" : "50%" }]}>
                <Pressable style={{ alignSelf: "center" }} onPress={() => onPressItem(_item, _index)} key={_index}>
                  {({ hovered }: PressAbleState) => {
                    // eslint-disable-next-line react-hooks/rules-of-hooks
                    const _buttonStyle = useAnimatedStyle(() => {
                      return {
                        justifyContent: "center",
                        alignItems: "center",
                        transform: [
                          {
                            scale: hovered ? withSpring(1.06) : withSpring(1),
                          },
                        ],
                      };
                    });
                    return (
                      <Animated.View style={_buttonStyle}>
                        <Block br={20} p={spacing.huge} bg={colors.backgroundForm} middle center>
                          <IconsYellowBanking name={_item.icon} size={64} />
                        </Block>
                        <StackSpacing size="small" />
                        <Text numberOfLines={2} style={styles.textName}>
                          {_item.name}
                        </Text>
                        <StackSpacing size="huge" />
                      </Animated.View>
                    );
                  }}
                </Pressable>
              </View>
            ))}
          </View>
        </Block>
        <ChangePassword ref={globalModalChangePasswordRef}/>
      </ScrollView>
    </Block>
  );
};

export default Settings;
